import { render, staticRenderFns } from "./MyFile.vue?vue&type=template&id=7072f9ee&scoped=true&"
import script from "./MyFile.vue?vue&type=script&lang=js&"
export * from "./MyFile.vue?vue&type=script&lang=js&"
import style0 from "./MyFile.vue?vue&type=style&index=0&id=7072f9ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072f9ee",
  null
  
)

export default component.exports